const productionApiBaseUrl = 'https://logistics-api.mak-h.com.ng/api/';

function resolveBaseUrl(): string {
  if (typeof window === 'undefined') {
    return productionApiBaseUrl;
  }

  const { hostname } = window.location;
  const isLocalHost = hostname === 'localhost' || hostname === '127.0.0.1';
  const isLanIpv4 = /^(10|127|172\.(1[6-9]|2\d|3[0-1])|192\.168)\.\d{1,3}\.\d{1,3}$/.test(hostname);

  if (isLocalHost || isLanIpv4) {
    return `http://${hostname}:5100/api/`;
  }

  return productionApiBaseUrl;
}

export const baseUrl = resolveBaseUrl();
